import React from 'react'
import {useResponsive} from 'app/styles'
import {DATE_REVERSE_2_FORMAT, dateFormatter, useI18n, _} from 'plugins/i18n'
import {Image} from 'plugins/images'
import Text from 'app/Components/twComponents/Text'
import {LocationIcon} from 'app/Components/Icon'
import ReservationCalendarSection from '../ReservationCalendarSection'
import {calcNumDays} from 'app/lib'
import {useReservationFormState} from '../hooks'

export const CalendarInputPanel = () => {
	const {isPhone} = useResponsive('isPhone')
	const {formValue} = useReservationFormState()
	const {dateRange, contract} = formValue || {}
	const {house} = contract || {}

	return (
		<div className="flex flex-col justify-center">
			<div className="flex flex-col md:text-center">
				<Text variant="heading2XL">{_`AvailabilityCalendarLabel`}</Text>
			</div>

			<ReservationCalendarSection
				name="dateRange"
				extraContractProps={{house, dateRange}}
				isPhone={isPhone}
			/>
		</div>
	)
}

export const DetailsImagePanel = ({
	house,
}: {
	house: Pick<House, 'mainImage'>
}) => {
	return (
		<div className="border-capGold min-w-80 rounded-lg border-1">
			<Image ratio={16 / 9} value={house.mainImage} />
		</div>
	)
}

export const DetailsHeaderPanel = ({
	contract,
}: {
	contract: Pick<Contract, 'house'>
}) => {
	const {getText} = useI18n()
	const {house} = contract || {}
	const {name, placeName, province, regionId} = house || {}
	return (
		<div className="flex flex-col">
			<Text variant="heading3XL">{name}</Text>
			<div className="flex gap-2">
				<LocationIcon height="1rem" />
				<Text variant="small" className="text-onTertiary">
					{[placeName, province, getText(regionId)].filter(Boolean).join(', ')}
				</Text>
			</div>
		</div>
	)
}

export const DetailsDateRage = ({
	contract,
	onClick,
}: {
	contract: Pick<Contract, 'beginDate' | 'endDate'>
	onClick?: () => void
}) => {
	const {beginDate, endDate} = contract || {}
	const stayDays = calcNumDays(beginDate, endDate)

	const beginDateFormat = dateFormatter(beginDate, DATE_REVERSE_2_FORMAT)
	const endDateFormat = dateFormatter(endDate, DATE_REVERSE_2_FORMAT)

	return (
		<>
			<div className="flex flex-col gap-2 lg:flex-row lg:gap-6">
				{/* Arrival */}
				<div className="flex justify-between gap-1 lg:flex-col">
					<Text variant="base" className="font-bold">
						{_`Arrival`}
					</Text>
					{onClick ? (
						<button
							type="button"
							onClick={onClick}
							className="cursor-pointer text-left"
						>
							<Text variant="base">{beginDateFormat}</Text>
						</button>
					) : (
						<Text variant="base">{beginDateFormat}</Text>
					)}
				</div>
				{/* Arrow */}
				<div className="hidden lg:block">
					<Text variant="heading2XL">→</Text>
				</div>
				{/* Departure */}
				<div className="flex justify-between gap-1 text-left lg:flex-col">
					<Text variant="base" className="font-bold">
						{_`Departure`}
					</Text>
					{onClick ? (
						<button
							type="button"
							onClick={onClick}
							className="cursor-pointer text-left"
						>
							<Text variant="base">{endDateFormat}</Text>
						</button>
					) : (
						<Text variant="base">{endDateFormat}</Text>
					)}
				</div>
			</div>
			<Text variant="base" className="font-bold">
				{stayDays} {_`nights`}{' '}
				{onClick && (
					<button
						type="button"
						onClick={onClick}
						className="cursor-pointer font-normal underline"
					>
						{_`change`}
					</button>
				)}
			</Text>
		</>
	)
}
